import React from 'react';
import '../style.css';
import {Form,Button,Container,Row,Col,Navbar,Nav,NavDropdown,FormControl,label,input,h2,h3,h4,h5} from 'react-bootstrap';

import styled from 'styled-components';
import '../assets/styles/sb-admin-2.css';
import '../assets/styles/sb-admin-2.min.css';
import DataGrid from '../Components/Misc/DataGrid';
import * as XLSX from 'xlsx';


class StoreExcelUpload extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            TmexcelData:[],
            AomexcelData:[],
            StoreexcelData:[],                
            headData:[],
            userhead:0,           
            tmusers:[],
            aomusers:[],
            storeusers:[],
            ready: false,
            columnstoview:["YearCode","WeekNo","FromDate","ToDate","Season"]          
                    }
                     }

     handleTmFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
         // this.setState({file:file.name})
          this.readExcelFile(file,'Tm');
        }
      };
      handleAomFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
         // this.setState({file:file.name})
          this.readExcelFile(file,'Aom');
        }
      };
      handleStoreFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
         // this.setState({file:file.name})
          this.readExcelFile(file,'Store');
        }
      };
    
       readExcelFile (file,filetype) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary'});
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(sheet,{raw: false}); // Convert sheet to JSON
          switch(filetype){
            case 'Tm':
              this.setState({TmexcelData:jsonData});
              break;
            case 'Aom':
              this.setState({AomexcelData:jsonData});
              break;
            case 'Store':
              this.setState({StoreexcelData:jsonData});
              break;  
          }
          
          console.log(jsonData);
        };
        reader.readAsBinaryString(file);
      };

      submitTmData=(event)=>{
        event.preventDefault();
        let postData = {
          'userdata':this.state.TmexcelData,
          'userhead':this.state.userhead
        };
        let url = process.env.REACT_APP_DEBUG_URL+'/api/uploadtmuserdata';
           let token =localStorage.getItem("UserToken");
           const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization': 'Bearer '+token },
            body: JSON.stringify(postData)
           // body: postData
        };
        fetch(url, requestOptions)
        .then(res => res.json())
        .then(result => {
     console.log(result)
     this.setState({tmusers:result.tmusers})

        })
      }

       submitAomData=(event)=>{
        event.preventDefault();
        let postData = {
          'userdata':this.state.AomexcelData
                       };
        let url = process.env.REACT_APP_DEBUG_URL+'/api/uploadaomuserdata';
           let token =localStorage.getItem("UserToken");
           const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization': 'Bearer '+token },
            body: JSON.stringify(postData)
           // body: postData
        };
        fetch(url, requestOptions)
        .then(res => res.json())
        .then(result => {
           this.setState({aomusers:result.aomusers})
     console.log(result)

        })
      }

       submitStoreData=(event)=>{
        event.preventDefault();
        let postData = {
          'userdata':this.state.StoreexcelData
                       };
        let url = process.env.REACT_APP_DEBUG_URL+'/api/uploadstoreuserdata';
           let token =localStorage.getItem("UserToken");
           const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization': 'Bearer '+token },
            body: JSON.stringify(postData)
           // body: postData
        };
        fetch(url, requestOptions)
        .then(res => res.json())
        .then(result => {
     console.log(result)
 this.setState({storeusers:result.users})
        })
      }


      
    
    componentDidMount() { 
      let url = process.env.REACT_APP_DEBUG_URL+'/api/getlfshead';
           let token =localStorage.getItem("UserToken");
           const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','Authorization': 'Bearer '+token }
           
        };
        fetch(url, requestOptions)
        .then(res => res.json())
        .then(result => {
         console.log('users=',result.users);
         this.setState({headData:result.users,ready:true})
        })
               
      }

handleChange = (event) => {   
    
    this.setState({[event.target.name]: event.target.value});    
  }
      seteditid=(editid)=>{}
      


      render() { 
        let projectname='TL Image Portal';
        const WorkArea = styled.div`
        background: white;
        left:250;
        height: 100vh;
        display: flex;
        
      `;
if(this.state.ready==false)
                  return(<div></div>)
                  else{
                     const head_dropdown=this.state.headData.map((item,l)=>{
       
        return <option  value={item.PK_UserID}>{item.FirstName+' '+(item.LastName==null?'':item.LastName)}</option>
    })
      
        return (
            <div id="content-wrapper" className="d-flex flex-column">            
            <div id="content" className='containerh'>              
              <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow" >              
               <div style={{fontSize:'50px',color:'rgb(12 16 167)'}}>{projectname}</div>               
              </nav>  
              <h1>BULK STORE UPLOAD</h1>
              <Container><Row>  
                 <Col xs="12" lg="12" >
                 <h2>Step 1</h2><br/> 
                 {this.state.userhead==0?null:<p style={{color:'green',fontWeight:'bold'}}>Head Selected</p>} 
                 </Col>      
               <Col xs="6" lg="4" >
                 <Form.Group controlId="formBasicEmail">
                   
                   <Form.Label>Head<b style={{color: "red"}}>(*)</b></Form.Label>
                   <Form.Control as="select"      id="userhead" className="margin-5" value={this.state.userhead} onChange={this.handleChange} name='userhead'>
                                     <option key ={0} value={0}>Select </option>
                                    
                                      {head_dropdown}
   
                                    
                                   
                                   
                                  </Form.Control>   
                   
                   
                 </Form.Group>
                 </Col> 
                   <Col xs="6" lg="4" ><Form.Group controlId="formBasicEmail"><Form.Label>OR</Form.Label>&nbsp;&nbsp;<Button variant="primary" type="button" onClick={()=>{this.props.refreshCallback('createhead')}}>
               Create Head
              </Button></Form.Group></Col>
     </Row>
     <hr></hr>
     {this.state.userhead==0?(<div></div>):
      (<div>
     <Row>
      <Col xs="12" lg="12" >
        <h2>Step 2</h2><br/>
        </Col>
        {this.state.tmusers.length>0?null:
        <Col  xs="12" lg="12" >
         <h2>Upload Excel File(TM USERS)[TM,UserID,PW]</h2>
                      <input type="file" accept=".xlsx,.xls" onChange={this.handleTmFileUpload} />
                      <Button variant="primary" type="button" onClick={this.submitTmData}>
                       Submit
                      </Button>
        </Col>
        }
         {this.state.tmusers.length==0?null:
        <Col xs="12" lg="12">
        <DataGrid  rowsarray={this.state.tmusers}  seteditid={this.seteditid } columns={["FirstName"]} showeditbutton={false}/>              
        </Col>
                  }
      </Row> 

        <hr></hr>
     <Row>
      <Col xs="12" lg="12" >
        <h2>Step 3</h2><br/>
        </Col>
         {this.state.aomusers.length>0?null:
        <Col  xs="12" lg="12" >
         <h2>Upload Excel File(AOM USERS)[AOM,UserID,PW]</h2>
                      <input type="file" accept=".xlsx,.xls" onChange={this.handleAomFileUpload} />
                      <Button variant="primary" type="button" onClick={this.submitAomData}>
                       Submit
                      </Button>
        </Col>
                  }
                   {this.state.aomusers.length==0?null:
        <Col xs="12" lg="12">
        <DataGrid  rowsarray={this.state.aomusers}  seteditid={this.seteditid } columns={["FirstName"]} showeditbutton={false}/>              
        </Col>
                  }
      </Row> 
        <hr></hr>
     <Row>
      <Col xs="12" lg="12" >
        <h2>Step 4</h2><br/>
        </Col>
        {this.state.storeusers.length>0?null:
        <Col  xs="12" lg="12" >
         <h2>Upload Excel File(STORE USERS)[Format,StoreCode,Store,AOM,TM,City,Zone,State,UserID,PW]</h2>
                      <input type="file" accept=".xlsx,.xls" onChange={this.handleStoreFileUpload} />
                      <Button variant="primary" type="button" onClick={this.submitStoreData}>
                       Submit
                      </Button>
        </Col>
                  }
                  {this.state.storeusers.length==0?null:
        <Col xs="12" lg="12">
        <DataGrid  rowsarray={this.state.storeusers}  seteditid={this.seteditid } columns={["FirstName"]} showeditbutton={false}/>              
        </Col>
                  }
      </Row> 
         </div>       )  }
                  
     </Container> 
      </div>
      
      <footer className="sticky-footer bg-white">
        <div className="container my-auto" style={{backgroundColor:'#fff'}}>
          <div className="copyright text-center my-auto">
            <span style={{fontSize:'25px'}}><a href='https://thinkmaster.technology' target='_blank'>Developed & Maintain by Thinkmaster Technology</a></span>
          </div>
        </div>
      </footer>
    </div>
        );
    }
      }




}

export default StoreExcelUpload;
 